(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tarim-collection-preview"]) return;
  try {
    
document.addEventListener('click',(event)=>{
 const open=event.target.closest('[data-tarim-open]');
 if(open){const dialog=document.getElementById(open.dataset.tarimOpen);if(dialog){dialog.showModal();}}
 const close=event.target.closest('[data-tarim-close]');
 if(close){close.closest('dialog').close();}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tarim-featured-pieces"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('tarim-featured-reveal')) {
  customElements.define('tarim-featured-reveal', class extends HTMLElement {
    connectedCallback() {
      if (!('IntersectionObserver' in window) || matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      this.observer?.disconnect();
      this.observer = new IntersectionObserver(entries => {
        for (const entry of entries) {
          if (!entry.isIntersecting) continue;
          entry.target.classList.remove('is-pending');
          entry.target.classList.add('is-visible');
          this.observer.unobserve(entry.target);
        }
      }, { threshold: 0.12, rootMargin: '0px 0px -24px 0px' });
      for (const piece of this.querySelectorAll('.tarim-featured__piece')) {
        if (piece.classList.contains('is-visible')) continue;
        piece.classList.add('is-pending');
        this.observer.observe(piece);
      }
    }
    disconnectedCallback() { this.observer?.disconnect(); }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tarim-pattern-reveal"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('tarim-pattern-reveal')) {
    customElements.define('tarim-pattern-reveal', class extends HTMLElement {
      connectedCallback() {
        this.motionQuery = matchMedia('(prefers-reduced-motion: reduce)');
        this.mobileQuery = matchMedia('(max-width: 989px)');
        this.controller = new AbortController();
        const signal = this.controller.signal;
        this.stage = this.querySelector('.tarim-pattern__stage');
        this.visual = this.querySelector('.tarim-pattern__image');
        this.intro = this.querySelector('.tarim-pattern__intro');
        this.story = this.querySelector('.tarim-pattern__story');
        this.progress = this.querySelector('.tarim-pattern__progress span');
        this.startScale = matchMedia('(max-width: 749px)').matches ? 1.85 : 2.35;
        this.complete = false;
        this.running = false;
        this.animations = [];
        this.configure = () => {
          const enabled = !this.motionQuery.matches && this.dataset.motionEnabled === 'true';
          this.toggleAttribute('data-motion', enabled);
          if (!enabled) this.finish();
          else if (!this.complete && !this.running) {
            this.attachInput();
            this.renderStart();
          }
          this.update();
        };
        this.update = () => {
          const wrapper = document.querySelector('.page-wrapper');
          const scrollTop = matchMedia('(min-width: 990px)').matches && wrapper ? wrapper.scrollTop : window.scrollY;
          this.toggleAttribute('data-header-revealed', scrollTop > 0);
          if (scrollTop > 0 && !this.complete && !this.running) this.play();
        };
        this.onWheel = event => {
          if (!this.canStart() && !this.running) return;
          if (event.ctrlKey || Math.abs(event.deltaY) <= Math.abs(event.deltaX)) return;
          if (this.running || event.deltaY > 0) {
            event.preventDefault();
            this.play();
          }
        };
        this.onTouchStart = event => {
          this.touchY = event.touches.length === 1 ? event.touches[0].clientY : null;
        };
        this.onTouchMove = event => {
          const y = event.touches.length === 1 ? event.touches[0].clientY : null;
          if (this.touchY == null || y == null) return;
          const delta = this.touchY - y;
          this.touchY = y;
          if ((this.running || this.canStart() && delta > 0) && delta !== 0) {
            if (event.cancelable) event.preventDefault();
            this.play();
          }
        };
        this.onTouchEnd = () => { this.touchY = null; };
        this.onResize = () => {
          const widthChanged = this.freezeMobileHeight();
          if (widthChanged && !this.complete && !this.running) {
            this.startScale = matchMedia('(max-width: 749px)').matches ? 1.85 : 2.35;
            this.renderStart();
          }
          this.update();
        };
        document.addEventListener('scroll', this.update, { passive: true, capture: true, signal });
        window.addEventListener('resize', this.onResize, { passive: true, signal });
        this.motionQuery.addEventListener('change', this.configure);
        this.freezeMobileHeight();
        this.configure();
      }
      attachInput() {
        this.inputController?.abort();
        this.inputController = new AbortController();
        const signal = this.inputController.signal;
        document.addEventListener('touchend', this.onTouchEnd, { passive: true, signal });
        document.addEventListener('touchcancel', this.onTouchEnd, { passive: true, signal });
        document.addEventListener('wheel', this.onWheel, { passive: false, signal });
        document.addEventListener('touchstart', this.onTouchStart, { passive: true, signal });
        document.addEventListener('touchmove', this.onTouchMove, { passive: false, signal });
      }
      freezeMobileHeight() {
        const width = document.documentElement.clientWidth;
        if (width === this.viewportWidth) return false;
        this.viewportWidth = width;
        this.style.removeProperty('--pattern-mobile-stage-height');
        if (this.mobileQuery.matches && this.stage) {
          const height = this.stage.getBoundingClientRect().height;
          this.style.setProperty('--pattern-mobile-stage-height', `${height}px`);
        }
        return true;
      }
      canStart() {
        return this.hasAttribute('data-motion') && !this.complete && this.getBoundingClientRect().top <= innerHeight / 2 && this.getBoundingClientRect().bottom > innerHeight / 2;
      }
      renderStart() {
        if (this.visual) this.visual.style.transform = `scale(${this.startScale})`;
        this.intro.style.opacity = '1';
        this.story.style.opacity = '0';
        this.story.style.transform = 'translateY(28px)';
        this.progress.style.transform = 'scaleX(0)';
      }
      play() {
        if (!this.canStart() || this.running) return;
        this.running = true;
        const timing = { duration: 750, easing: 'cubic-bezier(0.77, 0, 0.175, 1)', fill: 'forwards' };
        const animate = (element, frames, options = timing) => {
          if (element) this.animations.push(element.animate(frames, options));
        };
        animate(this.visual, [{ transform: `scale(${this.startScale})` }, { transform: 'scale(1)' }]);
        animate(this.intro, [{ opacity: 1 }, { opacity: 0 }], { ...timing, duration: 240, easing: 'cubic-bezier(0.23, 1, 0.32, 1)' });
        animate(this.story, [{ opacity: 0, transform: 'translateY(28px)' }, { opacity: 1, transform: 'translateY(0)' }], { ...timing, delay: 200, duration: 550, easing: 'cubic-bezier(0.23, 1, 0.32, 1)' });
        animate(this.progress, [{ transform: 'scaleX(0)' }, { transform: 'scaleX(1)' }]);
        Promise.all(this.animations.map(animation => animation.finished.catch(() => {}))).then(() => {
          if (this.isConnected) this.finish();
        });
      }
      finish() {
        this.complete = true;
        this.running = false;
        this.inputController?.abort();
        this.touchY = null;
        this.toggleAttribute('data-complete', true);
        if (this.visual) this.visual.style.transform = 'scale(1)';
        this.intro.style.opacity = '0';
        this.story.style.opacity = '1';
        this.story.style.transform = 'translateY(0)';
        this.progress.style.transform = 'scaleX(1)';
        this.animations.forEach(animation => animation.cancel());
        this.animations = [];
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.inputController?.abort();
        this.motionQuery?.removeEventListener('change', this.configure);
        this.animations.forEach(animation => animation.cancel());
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
